var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.25V6.375C9 5.87772 9.19754 5.40081 9.54917 5.04917C9.90081 4.69754 10.3777 4.5 10.875 4.5H18.375C18.8723 4.5 19.3492 4.69754 19.7008 5.04917C20.0525 5.40081 20.25 5.87772 20.25 6.375V17.625C20.25 18.1223 20.0525 18.5992 19.7008 18.9508C19.3492 19.3025 18.8723 19.5 18.375 19.5H11.25C10.2145 19.5 9 18.6605 9 17.625V15.75M13.5 15.75L17.25 12L13.5 8.25M3.75 12H16.5",
    stroke: "#F6F8FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.46570f273d9bd353f75d02c3bb32d7fc.svg";
export { ForwardRef as ReactComponent };